import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=de78fea2&lang=pug"
import script from "./PreviewCard.vue?vue&type=script&lang=js"
export * from "./PreviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports